/* VAULT - core global JS */
(function(){
  'use strict';
  var V = window.Vault = window.Vault || {};
  V.$ = function(s,r){ return (r||document).querySelector(s); };
  V.$$ = function(s,r){ return Array.from((r||document).querySelectorAll(s)); };
  V.on = function(el,ev,fn,opt){ if(el) el.addEventListener(ev,fn,opt||false); };
  V.formatMoney = function(cents){
    var n = Number(cents);
    if(isNaN(n)) n = 0;
    var amount = n / 100;
    var cur = (window.VAULT && VAULT.currency && VAULT.currency.active) || 'AUD';
    try { return new Intl.NumberFormat('en-AU',{style:'currency',currency:cur}).format(amount); }
    catch(e){ return '$' + amount.toFixed(2); }
  };
  V.debounce = function(fn,wait){
    var t; return function(){ var ctx=this,a=arguments; clearTimeout(t); t=setTimeout(function(){fn.apply(ctx,a);},wait); };
  };
  V.emit = function(n,d){ document.dispatchEvent(new CustomEvent(n,{detail:d||{}})); };
  V.toast = function(msg){
    var t = V.$('#toast'); if(!t) return;
    var span = t.querySelector('[data-toast-message]');
    if(span) span.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(V._toastT);
    V._toastT = setTimeout(function(){ t.classList.remove('is-visible'); }, 2400);
  };

  /* Header scroll shadow */
  var header = V.$('.site-header');
  if(header){
    var onScroll = function(){
      if(window.scrollY > 4) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* Mobile menu drawer */
  var menuDrawer = V.$('#menu-drawer');
  var drawerScrim = V.$('[data-drawer-scrim]');
  function openMenu(){
    if(!menuDrawer) return;
    menuDrawer.classList.add('is-open');
    menuDrawer.setAttribute('aria-hidden','false');
    if(drawerScrim){ drawerScrim.hidden = false; drawerScrim.classList.add('is-open'); }
    document.body.classList.add('no-scroll');
  }
  function closeMenu(){
    if(!menuDrawer) return;
    menuDrawer.classList.remove('is-open');
    menuDrawer.setAttribute('aria-hidden','true');
    if(drawerScrim){ drawerScrim.classList.remove('is-open'); setTimeout(function(){drawerScrim.hidden=true;},300); }
    document.body.classList.remove('no-scroll');
  }
  V.$$('[data-drawer-open]').forEach(function(btn){ V.on(btn,'click',openMenu); });
  V.$$('[data-drawer-close]').forEach(function(btn){ V.on(btn,'click',closeMenu); });
  V.on(drawerScrim,'click',closeMenu);
  /* Mobile submenu toggle */
  V.$$('[data-submenu-toggle]').forEach(function(btn){
    V.on(btn,'click',function(){
      var sub = btn.nextElementSibling;
      if(!sub) return;
      var open = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Footer accordion: closed on mobile (clean), open on desktop (synced with inline script and on resize) */
  var footerCols = V.$$('.site-footer__col');
  if (footerCols.length) {
    var syncFooter = function(){
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      footerCols.forEach(function(col){
        if (isMobile) {
          // On mobile, only force-collapse if user hasn't manually opened it
          if (!col.dataset.userToggled) col.open = false;
        } else {
          col.open = true;
        }
      });
    };
    footerCols.forEach(function(col){
      // Track user-initiated toggles on mobile so resize doesn't reset their state
      col.addEventListener('toggle', function(){
        if (window.matchMedia('(max-width: 640px)').matches) {
          col.dataset.userToggled = '1';
        }
      });
      // Prevent click on summary from toggling on desktop
      var summary = col.querySelector('.site-footer__col-title');
      if (summary) {
        summary.addEventListener('click', function(e){
          if (!window.matchMedia('(max-width: 640px)').matches) e.preventDefault();
        });
      }
    });
    window.addEventListener('resize', V.debounce(syncFooter, 150));
    syncFooter(); // Run on initial load too, not just on resize
  }

  /* Cart drawer triggers (handled in cart.js for state) */
  V.$$('[data-cart-open]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('cart:open'); }); });
  V.$$('[data-cart-close]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('cart:close'); }); });

  /* Search modal */
  V.$$('[data-search-open]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('search:open'); }); });
  V.$$('[data-search-close]').forEach(function(btn){ V.on(btn,'click',function(){ V.emit('search:close'); }); });

  /* ESC closes drawers/modals */
  document.addEventListener('keydown',function(e){
    if(e.key !== 'Escape') return;
    closeMenu();
    V.emit('cart:close');
    V.emit('search:close');
  });

  /* Mega menu — hover for mouse, click for touch laptops, keyboard for a11y */
  var megaTriggers = V.$$('[data-mega-trigger]');
  var megas = V.$$('.mega');
  var megaTimeout;
  var openMegaIdx = -1;
  function closeAllMegas(){
    megas.forEach(function(m,i){
      m.classList.remove('is-open');
      var t = megaTriggers[i];
      var l = t && t.querySelector('.nav-link');
      if(l) l.setAttribute('aria-expanded','false');
    });
    openMegaIdx = -1;
  }
  megaTriggers.forEach(function(trig, idx){
    var link = trig.querySelector('.nav-link');
    var mega = megas[idx];
    if(!mega) return;
    if(link){ link.setAttribute('aria-haspopup','true'); link.setAttribute('aria-expanded','false'); }
    function open(){
      clearTimeout(megaTimeout);
      // Close any other open mega panel
      megas.forEach(function(m,i){
        if(i !== idx){
          m.classList.remove('is-open');
          var ll = megaTriggers[i] && megaTriggers[i].querySelector('.nav-link');
          if(ll) ll.setAttribute('aria-expanded','false');
        }
      });
      mega.classList.add('is-open');
      if(link) link.setAttribute('aria-expanded','true');
      openMegaIdx = idx;
    }
    function close(){
      megaTimeout = setTimeout(function(){
        mega.classList.remove('is-open');
        if(link) link.setAttribute('aria-expanded','false');
        if(openMegaIdx === idx) openMegaIdx = -1;
      }, 120);
    }
    // Mouse
    V.on(trig,'mouseenter',open);
    V.on(trig,'mouseleave',close);
    V.on(mega,'mouseenter',function(){clearTimeout(megaTimeout);});
    V.on(mega,'mouseleave',close);
    // Touch / click — toggle, and stop the link from navigating on the first tap
    if(link){
      V.on(link,'click',function(e){
        // Only intercept if we're on a touch-primary device or there's submenu content.
        // Allow normal navigation if the user is using a mouse and already saw the hover panel.
        var isTouch = !window.matchMedia('(hover: hover)').matches;
        if(isTouch){
          e.preventDefault();
          if(openMegaIdx === idx) closeAllMegas();
          else open();
        }
      });
      // Keyboard: Enter/Space opens, ArrowDown moves into the panel, Escape closes
      V.on(link,'keydown',function(e){
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          if(openMegaIdx === idx) closeAllMegas();
          else { open(); var firstLink = mega.querySelector('a'); if(firstLink) setTimeout(function(){firstLink.focus();}, 80); }
        } else if(e.key === 'ArrowDown'){
          e.preventDefault();
          open();
          var firstLink = mega.querySelector('a');
          if(firstLink) setTimeout(function(){firstLink.focus();}, 80);
        } else if(e.key === 'Escape'){
          closeAllMegas();
        }
      });
    }
    // Escape inside the panel returns focus to the trigger
    V.on(mega,'keydown',function(e){
      if(e.key === 'Escape'){
        closeAllMegas();
        if(link) link.focus();
      }
    });
  });
  // Click outside closes any open mega panel
  document.addEventListener('click', function(e){
    if(openMegaIdx === -1) return;
    if(e.target.closest('[data-mega-trigger]') || e.target.closest('.mega')) return;
    closeAllMegas();
  });

  /* Reveal on scroll */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    },{threshold:0.1, rootMargin:'0px 0px -10% 0px'});
    V.$$('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    V.$$('.reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* Mobile: reveal the product-card quick-add button only once the user has
     scrolled down a bit, instead of showing it immediately on load.
     Desktop uses hover (handled in CSS) so this is scoped to <=768px. */
  (function(){
    var mq = window.matchMedia('(max-width: 768px)');
    var cards = V.$$('[data-product-card]');
    if(!cards.length) return;

    // How far the user must scroll before quick-add buttons start appearing.
    var SCROLL_TRIGGER = 320;
    var revealIo = null;
    var armed = false; // becomes true once the user has scrolled past the trigger

    function clearAll(){ cards.forEach(function(c){ c.classList.remove('quick-revealed'); }); }

    function observeCards(){
      if(!('IntersectionObserver' in window)){
        cards.forEach(function(c){ c.classList.add('quick-revealed'); });
        return;
      }
      revealIo = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            en.target.classList.add('quick-revealed');
            revealIo.unobserve(en.target);
          }
        });
      }, {threshold: 0, rootMargin: '0px 0px -10% 0px'});
      cards.forEach(function(c){ revealIo.observe(c); });
    }

    function onScroll(){
      if(armed || !mq.matches) return;
      if(window.scrollY > SCROLL_TRIGGER){
        armed = true;
        window.removeEventListener('scroll', onScroll);
        // From here on, reveal each card as it comes into view.
        observeCards();
      }
    }

    function setup(){
      if(!mq.matches){
        // Desktop / tablet: hover handles it; tear down mobile behaviour.
        window.removeEventListener('scroll', onScroll);
        if(revealIo){ revealIo.disconnect(); revealIo = null; }
        armed = false;
        clearAll();
        return;
      }
      // Mobile: start hidden, wait for scroll.
      armed = false;
      clearAll();
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll(); // in case the page is already loaded mid-scroll (e.g. back nav)
    }

    setup();
    if(mq.addEventListener){ mq.addEventListener('change', setup); }
    else if(mq.addListener){ mq.addListener(setup); }
  })();

  /* Qty controls (delegated) */
  document.addEventListener('click',function(e){
    var dec = e.target.closest('[data-qty-decrement]');
    var inc = e.target.closest('[data-qty-increment]');
    if(!dec && !inc) return;
    var wrap = (dec||inc).closest('.qty-control');
    if(!wrap) return;
    var input = wrap.querySelector('input');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    var min = parseInt(input.min,10);
    if(isNaN(min)) min = 0;
    var max = parseInt(input.max,10);
    if(dec) v = Math.max(min, v-1);
    if(inc) v = (!isNaN(max) ? Math.min(max, v+1) : v+1);
    input.value = v;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* Sticky mobile ATC */
  var mainAtc = V.$('[data-main-atc]');
  var stickyAtc = V.$('[data-sticky-atc]');
  if(mainAtc && stickyAtc && 'IntersectionObserver' in window){
    var atcIo = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting) stickyAtc.classList.remove('is-visible');
        else stickyAtc.classList.add('is-visible');
      });
    });
    atcIo.observe(mainAtc);
    var stickyBtn = V.$('[data-sticky-atc-btn]');
    if(stickyBtn){
      V.on(stickyBtn,'click',function(){
        var form = V.$('.product-form');
        if(!form) return;
        // If the product has variants and the user hasn't been to the variant picker yet,
        // smooth-scroll there instead of submitting. Less guesswork, fewer wrong-variant orders.
        var hasVariants = stickyBtn.getAttribute('data-product-has-variants') === 'true';
        var variantPicker = V.$('.product-options', form);
        if(hasVariants && variantPicker){
          var picker = variantPicker.getBoundingClientRect();
          // Only scroll if the picker is currently above the viewport (i.e. user scrolled past it).
          // If it's still on screen below, just submit — they've made their choice.
          if(picker.top < 0){
            window.scrollTo({
              top: window.scrollY + picker.top - 100, // 100px breathing room above
              behavior: 'smooth'
            });
            return;
          }
        }
        var submitBtn = form.querySelector('[type="submit"]');
        if(submitBtn) submitBtn.click();
      });
    }
  }

  /* Product gallery */
  var gallerySlides = V.$$('[data-gallery-slides] [data-media-id]');
  var galleryThumbs = V.$$('[data-thumb]');
  var galleryCurrent = V.$('[data-gallery-current]');
  function showSlide(idx){
    gallerySlides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
    galleryThumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===idx); });
    if(galleryCurrent) galleryCurrent.textContent = (idx+1);
  }
  galleryThumbs.forEach(function(t,i){ V.on(t,'click',function(){ showSlide(i); }); });
  V.on(V.$('[data-gallery-prev]'),'click',function(){
    var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
    showSlide((active - 1 + gallerySlides.length) % gallerySlides.length);
  });
  V.on(V.$('[data-gallery-next]'),'click',function(){
    var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
    showSlide((active + 1) % gallerySlides.length);
  });
  // Touch swipe on the gallery main area
  var gallerySlidesWrap = V.$('[data-gallery-slides]');
  if(gallerySlidesWrap && gallerySlides.length > 1){
    var touchStartX = 0, touchStartY = 0, touchActive = false;
    gallerySlidesWrap.addEventListener('touchstart', function(e){
      if(!e.touches || !e.touches[0]) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
    }, {passive: true});
    gallerySlidesWrap.addEventListener('touchend', function(e){
      if(!touchActive || !e.changedTouches || !e.changedTouches[0]) return;
      touchActive = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      // Only register horizontal swipes; ignore vertical scrolls
      if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var active = gallerySlides.findIndex(function(s){return s.classList.contains('is-active');});
      if(dx < 0) showSlide((active + 1) % gallerySlides.length);
      else showSlide((active - 1 + gallerySlides.length) % gallerySlides.length);
    }, {passive: true});
  }

  /* Countdown */
  V.$$('[data-countdown]').forEach(function(el){
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(target)) return;
    var days = el.querySelector('[data-cd-days]');
    var hours = el.querySelector('[data-cd-hours]');
    var mins = el.querySelector('[data-cd-mins]');
    var secs = el.querySelector('[data-cd-secs]');
    function pad(n){return n<10?'0'+n:''+n;}
    var intervalId = null;
    function tick(){
      var now = Date.now();
      var diff = Math.max(0, target - now);
      var d = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);
      if(days) days.textContent = pad(d);
      if(hours) hours.textContent = pad(h);
      if(mins) mins.textContent = pad(m);
      if(secs) secs.textContent = pad(s);
      if(diff === 0 && intervalId !== null){
        clearInterval(intervalId);
        intervalId = null;
        el.classList.add('is-expired');
      }
    }
    tick();
    intervalId = setInterval(tick, 1000);
  });

  /* Cart count animation when changed */
  document.addEventListener('cart:updated',function(e){
    var count = e.detail && e.detail.item_count;
    var badges = V.$$('[data-cart-count]');
    badges.forEach(function(b){
      if(count > 0){ b.hidden = false; b.textContent = count; }
      else { b.hidden = true; }
      b.classList.add('is-bumped');
      setTimeout(function(){ b.classList.remove('is-bumped'); }, 320);
    });
  });

  /* Product recommendations fetch */
  V.$$('[data-product-recommendations]').forEach(function(el){
    var url = el.getAttribute('data-url');
    if(!url) return;
    fetch(url).then(function(r){return r.text();}).then(function(html){
      var div = document.createElement('div');
      div.innerHTML = html;
      var inner = div.querySelector('.products-row, .products-grid');
      if(inner) el.innerHTML = inner.outerHTML;
    }).catch(function(){});
  });

  /* Collection sort dropdown — preserve filters and other params, reset page to 1 */
  V.$$('[data-collection-sort]').forEach(function(select){
    V.on(select, 'change', function(){
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      } catch(e) {
        // Fallback for older browsers without URL constructor
        window.location.search = '?sort_by=' + encodeURIComponent(select.value);
      }
    });
  });

  /* Collection mobile filter drawer */
  var collFilters = V.$('[data-coll-filters]');
  if(collFilters){
    var collScrim = document.createElement('div');
    collScrim.className = 'coll-filters-scrim';
    collScrim.setAttribute('aria-hidden','true');
    document.body.appendChild(collScrim);
    function openCollFilters(){
      collFilters.classList.add('is-open');
      collFilters.setAttribute('aria-hidden','false');
      collScrim.classList.add('is-open');
      document.body.classList.add('no-scroll');
    }
    function closeCollFilters(){
      collFilters.classList.remove('is-open');
      collFilters.setAttribute('aria-hidden','true');
      collScrim.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
    V.$$('[data-mobile-filter-open]').forEach(function(btn){ V.on(btn,'click',openCollFilters); });
    V.$$('[data-mobile-filter-close]').forEach(function(btn){ V.on(btn,'click',closeCollFilters); });
    V.on(collScrim, 'click', closeCollFilters);
    // Close on Escape (additive to existing global ESC handler)
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && collFilters.classList.contains('is-open')) closeCollFilters();
    });
  }
})();
